// import store from '@/store'

import columns from './tableConfig'
import { searchItems } from './searchFormConfig'
import { GetAllOrders } from '../../../api/orderMana'
import DetailsTerminalDrawer from './components/DetailsTerminalDrawer/index'
let searchCache = {}
// const enumsData = store.state.enumsStore.enumsData
// console.log(enumsData)

const payTypes = {
  1:{
    'code': 1,
    'name': '微信扫码'
  },
  2: {
    'code': 2,
    'name': '支付宝扫码'
  }
}

const payStates = {
  1: {
    'code': 1,
    'name':'未支付'
  }
  ,
  2: {
    'code':2,
    'name':'支付成功'
  }
  ,
  3: {
    'code':3,
    'name': '部分退款'
  }
  ,
  4: {
    'code': 4,
    'name':'全额退款'
  }
  ,
  5: {
    'code':5,
    'name': '关闭支付'
  }
  ,
  6: {
    'code': 6,
    'name':'超时关闭'
  }
}

export default {
  name: 'OrdersIndex',
  components: {
    DetailsTerminalDrawer
  },
  data() {
    return {
      searchItems,
      searching: false,
      columns,
      payStates,
      payTypes,
      data: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      states: {
        0: '启用',
        1: '禁用'
      },
      showEditAppModal: false,
      showAddNumberModal: false,
      showDetailDrawer: false,
      targetApp: null,
      targetTerminal: null
    }
  },
  watch: {
    // '$route.params.clientId': function(id) {
    //   if (id) {
    //     this.$refs.searchForm.resetFields()
    //     this.$refs.searchForm.setFieldsValue({ customerId: id })
    //     this.$refs.searchForm.handlerSearch()
    //
    //     // 清理页面跳转时在路由上传递的搜索条件
    //     this.$route.params.clientId = undefined
    //   }
    // }
  },
  created() {
    this.$nextTick(async () => {
      this.getAllOrders()
      // const id = this.$route.params.clientId
      // if (id) {
      //   this.$refs.searchForm.setFieldsValue({ customerId: id })
      //   // 清理页面跳转时在路由上传递的搜索条件
      //   this.$route.params.clientId = undefined
      // }
      // this.$refs.searchForm.handlerSearch()
    })
  },

  methods: {
    // 查询应用
    async getAllOrders(page = 1, searchData) {
      try {
        this.loading = true
        // 确定搜索条件
        searchData = searchData || searchCache
        // 缓存搜索条件
        searchCache = searchData
        let {
          transactionNo,
          dateTimeRange
        } = searchData

        let updatedAtFrom, updatedAtTo
        if (dateTimeRange && dateTimeRange.length) {
          updatedAtFrom = dateTimeRange[0].format('YYYY-MM-DD HH:mm:ss')
          updatedAtTo = dateTimeRange[1].format('YYYY-MM-DD HH:mm:ss')
        }

        await GetAllOrders({
          transactionNo,
          updatedAtFrom,
          updatedAtTo,
          page,
          perPage: this.pagination.pageSize
        }).then(res => {
          let data = res.data.collection
          this.data = data.map(app => Object.assign(app, { key: app.id }))
          this.pagination.current = page
          this.pagination.total = res.data.size
        })
      } catch (error) {
      }
      this.loading = this.searching = false
    },
    // 翻页
    handlePageTurn(pagination, filters, sorter) {
      const { current } = pagination
      this.getAllOrders(current)
    },
    // 打开应用详情抽屉弹窗
    handlerDetailDrawer(data) {
      this.targetTerminal = data
      this.showDetailDrawer = true
    },
    // 关闭应用详情抽屉弹窗
    handlerCloseDetailDrawer() {
      this.showDetailDrawer = false
      setTimeout(() => {
        this.targetTerminal = null
      }, 500)
    }
  }
}
